import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, CssBaseline, Box, CircularProgress } from '@mui/material';
import { theme } from './theme/theme.ts';
import MainLayout from './components/layout/MainLayout.tsx';
import VerificacionesPendientes from './components/VerificacionesPendientes.tsx';
import AdminPanel from './components/AdminPanel.tsx';
import ClienteFirma from './components/ClienteFirma.tsx';
import GenerarLink from './components/GenerarLink.tsx';
import FirmarDocumento from './components/FirmarDocumento.tsx';
import VerificarIdentidad from './components/VerificarIdentidad.tsx';
import FirmaPorLink from './components/FirmaPorLink.tsx';
import Login from './components/auth/Login.tsx';
import Register from './components/Register.tsx';
import ListadoDocumentos from './components/ListadoDocumentos.tsx';
import DocumentosLista from './pages/DocumentosLista.tsx';
import ListadoClientes from './components/ListadoClientes.tsx';
import UnifiedDashboard from './components/UnifiedDashboard.tsx';
import { authApi } from './services/api.ts';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState<any>(null);
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    try {
      // Verificar si hay un token guardado al cargar la aplicación
      const token = localStorage.getItem('authToken');
      const userData = localStorage.getItem('userData');
      
      console.log('Initialization - token:', token ? 'exists' : 'not found');
      console.log('Initialization - userData:', userData ? 'exists' : 'not found');
      
      if (token && userData && userData !== 'undefined' && userData !== 'null') {
        try {
          const parsedUserData = JSON.parse(userData);
          console.log('Initialization - parsed userData:', parsedUserData);
          if (parsedUserData && typeof parsedUserData === 'object') {
            setIsAuthenticated(true);
            setUser(parsedUserData);
            console.log('Initialization - Authentication set to true');
          } else {
            throw new Error('Invalid user data format');
          }
        } catch (parseError) {
          console.error('Error parsing user data:', parseError);
          // Si hay error al parsear, limpiar localStorage
          localStorage.removeItem('authToken');
          localStorage.removeItem('userData');
          setIsAuthenticated(false);
          setUser(null);
        }
      } else {
        // Si no hay datos válidos, limpiar localStorage
        localStorage.removeItem('authToken');
        localStorage.removeItem('userData');
        setIsAuthenticated(false);
        setUser(null);
        console.log('Initialization - No valid data, authentication set to false');
      }
    } catch (error) {
      console.error('Error initializing app:', error);
      // En caso de cualquier error, limpiar localStorage y resetear estado
      localStorage.removeItem('authToken');
      localStorage.removeItem('userData');
      setIsAuthenticated(false);
      setUser(null);
    } finally {
      setIsInitialized(true);
      console.log('Initialization - App initialized');
    }
  }, []);

  const handleLoginSuccess = (userData: any) => {
    console.log('Login success, userData:', userData);
    setIsAuthenticated(true);
    setUser(userData);
  };

  const handleLogout = async () => {
    try {
      await authApi.logout();
    } catch (error) {
      console.error('Error en logout:', error);
    } finally {
      // Siempre limpiar localStorage independientemente del resultado
      localStorage.removeItem('authToken');
      localStorage.removeItem('userData');
      setIsAuthenticated(false);
      setUser(null);
    }
  };

  // Mostrar loading mientras se inicializa
  if (!isInitialized) {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          <CircularProgress />
        </Box>
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router basename="/">
        {isAuthenticated ? (
          <>
            {console.log('🔐 Usuario autenticado, renderizando rutas protegidas')}
            <MainLayout user={user} onLogout={handleLogout}>
              <Routes>
              {/* Rutas protegidas */}
              <Route path="/dashboard" element={<UnifiedDashboard user={user} />} />
              <Route path="/admin" element={
                <>
                  {console.log('🏛️ Renderizando AdminPanel para ruta /admin')}
                  <AdminPanel />
                </>
              } />
              <Route path="/verificaciones-pendientes" element={<VerificacionesPendientes />} />
              <Route path="/documentos" element={<DocumentosLista />} />
              <Route path="/clientes" element={<ListadoClientes />} />
              <Route path="/adobe-sign" element={<UnifiedDashboard user={user} />} />
              <Route path="/generar-link" element={<GenerarLink />} />
              <Route path="/firmar-documento" element={<FirmarDocumento />} />
              <Route path="/verificar-identidad" element={<VerificarIdentidad />} />
              <Route path="/firma-por-link" element={<FirmaPorLink />} />
              
              {/* Cliente - Firma por Link (pública) */}
              <Route path="/firma/:token" element={<ClienteFirma />} />
              
              {/* Ruta por defecto */}
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
              </Routes>
            </MainLayout>
          </>
                  ) : (
            <>
              {console.log('❌ Usuario NO autenticado, renderizando rutas de login')}
              <Routes>
            {/* Rutas de autenticación */}
            <Route path="/login" element={<Login onLoginSuccess={handleLoginSuccess} />} />
            <Route path="/register" element={<Register onRegisterSuccess={handleLoginSuccess} />} />
            <Route path="/firma/:token" element={<ClienteFirma />} />
              <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
          </>
        )}
      </Router>
    </ThemeProvider>
  );
}

export default App; 